exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer{position:fixed;bottom:0;z-index:10;width:231px;height:53px;background:none;border-top:1px solid #ededed;padding:10px;padding-right:11px;background-color:#fff}.footer .top-left-footer{width:231px;display:flex;align-items:center;justify-content:space-between}.footer .top-left-footer .logo{position:relative;left:5px;display:flex;align-items:center;width:100px;font-size:10px;color:rgba(0,0,0,.502)}.footer .top-left-footer .logo svg{width:50px}.footer .top-left-footer .logo span{margin-left:5px}.footer .top-left-footer .social li{margin-right:15px;display:inline}.footer .top-left-footer .social li a{text-decoration:none}.footer .top-left-footer .social svg{width:12px;height:12px;cursor:pointer}.footer .bottom-left-footer{padding-top:7px;display:flex;justify-content:space-around;font-size:11px}.footer .bottom-left-footer a{color:#a1a1a1;text-decoration:none}.footer .bottom-left-footer a:hover{text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/footer/footer.scss
// module id = 520
// module chunks = 0